export default __webpack_public_path__ + "static/media/k2.80393260.svg";